import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import useDrawer from 'common/components/drawer/useDrawer';
import TableActions from 'components/layouts/table';
import Form from './form';

import edit from 'assets/svg/actions/edit-empty.svg';
import EnumsDropdown from '../Dropdown';
import company from 'assets/svg/actions/company.svg';

const WidgetTypes = () => {
  const [active, setActive] = useState(null);
  const [editType, setEdit] = useState(null);
  const drawer = useDrawer();
  const table = useTable({
    label: 'widget_types',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true
      },
      {
        header: 'Label',
        key: 'label',
        type: 'string',
        sort: true
      },
      {
        header: 'Description',
        key: 'description',
        type: 'string',
        sort: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center'
      }
    ]
  });
  return (
    <Row className="widget-types-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Widget types"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[{ type: 'search' }]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} editType={editType} />}
          rows={{
            actions: {
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    setEdit('edit');
                    drawer.open();
                  }
                },
                {
                  label: 'Edit Visibility',
                  icon: company,
                  onClick: (_, row) => {
                    setEdit('visibility');
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            }
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default WidgetTypes;
